import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'sb-quick-action-card',
	standalone: true,
	imports: [MatCardModule, RouterModule],
	template: `
		<a class="anchor-content" [routerLink]="model.route">
			<mat-card class="card-container {{ colorClass }}">
				<mat-card-header class="card-header">
					<mat-card-title>{{ model.title }}</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<p>{{ model.description }}</p>
				</mat-card-content>
			</mat-card>
		</a>
	`,
	styleUrl: './quick-action-card.component.less',
})
export class QuickActionCardComponent {
	/** Model containing the content for the card */
	@Input() model: QuickActionCardModel;
	/** A sequential zero-based index used to set the color for the card */
	@Input() colorIndex = 0;

	private readonly colorCount = 3; // Number of different colors available

	protected get colorClass() {
		const index = (this.colorIndex % this.colorCount) + 1;
		return `color-${index}`;
	}
}

export interface QuickActionCardModel {
	title: string;
	description: string;
	icon?: string;
	route: string;
}
